
<grid :elements="gridElements" :layout="layout" :vertical-alignment="filterElement.vertical_alignment">
  <template #element="slotProps">
    <list-view-filter-grid-element
      :filter-element="slotProps.element"
      :class="slotProps.classes"
      :key="slotProps.index"
    ></list-view-filter-grid-element>
  </template>
  <template #empty="slotProps">
    <div
      :class="slotProps.classes"
      :key="slotProps.index"
    ></div>
  </template>
</grid>
